module.exports = __webpack_public_path__ + "img/expensesTypes.9e20068a.svg";